export default {
  SET_LIST_PRIORITIES(state, payload) {
    state.priorities.data = payload.data;
    state.priorities.total = payload.total;
    state.priorities.count = payload.count;
  },
};
